import { Controller } from 'stimulus';
import { columnFilterService } from '../libs/column_filter_service';
import { uiService } from '../libs/ui_service';

export default class extends Controller {
  show() {
    columnFilterService.toggleTooltip();
    columnFilterService.updateFilters();
  }

  cancel() {
    columnFilterService.clearAllSelectedFilters();
    uiService.updateTable();
    uiService.applyDefaultTableSort();
    uiService.closeModals();
  }

  apply() {
    uiService.updateTable();
    uiService.applyDefaultTableSort();
    uiService.closeModals();
  }

  activateAll(event) {
    columnFilterService.setAllFilters(event.target);
    columnFilterService.updateFiltersCount();
  }
}
